// Anchored at both ends, so a nested path or a campaign id never matches.
const ACCESS_VERIFICATION_ROUTE = /^\/accounts\/[^/]+\/assistants\/[^/]+\/access-verification\/?$/;

export function isAccessVerificationPath(pathname: string): boolean {
  return ACCESS_VERIFICATION_ROUTE.test(pathname);
}
